export const SET_LECTURES = 'SET_LECTURES';
export const SET_STUDENTS = 'SET_STUDENTS';
export const SET_CHAT = 'SET_CHAT';
export const SET_MESSAGES = 'SET_MESSAGES';
